var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Gradiente_sem_nome_19);\n      }\n\n      .st1 {\n        fill: url(#Gradiente_sem_nome_191);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_19",
    "data-name": "Gradiente sem nome 19",
    x1: 207.84,
    y1: 165.52,
    x2: 305.17,
    y2: 165.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_191",
    "data-name": "Gradiente sem nome 19",
    x1: 0,
    y1: 256,
    x2: 512,
    y2: 256,
    xlinkHref: "#Gradiente_sem_nome_19"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8_Motorcycle"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.83,151.98c1.92-2.35,4.05-4.43,6.35-6.29-44.93-9.16-71.24,9.81-97.33,39.73,48.13,5.11,59.34,4.49,90.99-33.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.24,271.07c-12.97,0-25.23,2.98-36.26,8.16l-15.74-24.97c29.7-15.36,52.54-8.85,80.59-10.4,10.08,0,18.93-5.65,23.2-14.77,4.27-9.12,2.88-19.57-3.57-27.25l-89.71-106.99c-8.16-9.71-21.39-12.53-32.43-7.63h-.05l-35.47-16.75c-5.28-2.51-11.68-.21-14.19,5.12-2.51,5.33-.21,11.68,5.12,14.19l29.44,13.92c-3.29,8.55-1.57,19.63,5.39,27.47l28.27,32.11c1.76,1.97,1.71,4.96-.11,6.88-1.71,1.81-4.43,2.13-6.51.75l-15.73-10.29c-10.72-7.04-25.01-4.91-33.28,5.01-38.88,46.61-58.56,46.77-114.77,40.37-21.44-2.51-38.77-10.08-51.52-22.56-21.12-20.69-46.45-33.55-73.23-37.12l-40.11-5.33c-15.3-2.11-29.07,9.88-29.07,25.44,0,9.33,5.07,17.92,13.23,22.45,20.85,11.57,91.09,50.61,117.55,67.52,6.26,4,11.52,8.56,16.1,13.45l-16.99,17.94c-14.22-10.46-31.71-16.73-50.68-16.73-47.26,0-85.71,38.45-85.71,85.76s38.45,85.71,85.71,85.71,85.76-38.45,85.76-85.71c0-20.65-7.33-39.61-19.53-54.43l14.13-14.92c13.63,25.45,13.51,55.12,11.43,74.1-2.13,18.98,12.84,35.47,31.79,35.47h69.6c14.24,0,26.93-9.6,30.83-23.31l17.55-62.13c5.12-18.14,15.56-33.75,29.27-45.42l15.37,24.39c-19.13,15.74-31.36,39.59-31.36,66.26,0,47.25,38.45,85.71,85.71,85.71s85.76-38.45,85.76-85.71c0-47.31-38.45-85.76-85.76-85.76h0ZM128.79,356.81c0,23.74-19.32,43.06-43.06,43.06s-43.07-19.32-43.07-43.06,19.32-43.06,43.07-43.06c7.59,0,14.72,1.99,20.92,5.45l-15.7,16.58c-1.68-.42-3.41-.7-5.22-.7-11.99,0-21.74,9.75-21.74,21.73s9.75,21.73,21.74,21.73,21.73-9.75,21.73-21.73c0-2.21-.43-4.31-1.05-6.33l15.71-16.59c4.2,6.65,6.67,14.49,6.67,22.92h0ZM426.27,399.87c-23.74,0-43.06-19.32-43.06-43.06,0-11.44,4.52-21.83,11.82-29.55l12.18,19.33c-1.65,3.06-2.67,6.51-2.67,10.22,0,11.98,9.75,21.73,21.73,21.73s21.73-9.75,21.73-21.73-9.75-21.73-21.73-21.73c-.35,0-.67.09-1.02.1l-12.19-19.34c4.17-1.35,8.6-2.09,13.21-2.09,23.74,0,43.06,19.32,43.06,43.06,0,23.74-19.32,43.06-43.06,43.06h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.416ea3507e86aa19066715d9a4b6ee85.svg";
export { ForwardRef as ReactComponent };